import { render, staticRenderFns } from "./ChinaAreaData.vue?vue&type=template&id=20fa47a6&scoped=true"
import script from "./ChinaAreaData.vue?vue&type=script&lang=js"
export * from "./ChinaAreaData.vue?vue&type=script&lang=js"
import style0 from "./ChinaAreaData.vue?vue&type=style&index=0&id=20fa47a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fa47a6",
  null
  
)

export default component.exports